import { render, staticRenderFns } from "./PerformerMovieItem.vue?vue&type=template&id=573ca89d&scoped=true&"
import script from "./PerformerMovieItem.vue?vue&type=script&lang=js&"
export * from "./PerformerMovieItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformerMovieItem.vue?vue&type=style&index=0&id=573ca89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ca89d",
  null
  
)

export default component.exports